import { createFileRoute, Navigate } from "@tanstack/react-router";
import { EditCompanyPage } from "@/pages/edit-company/ui/edit-company-page";
import { useIsOwnerOrAdmin } from "@/entities/user/hooks/use-is-owner-or-admin";

const EditCompanyRoute = () => {
  const { isOwnerOrAdmin } = useIsOwnerOrAdmin();

  // Redirect non-admin users
  if (!isOwnerOrAdmin) {
    return <Navigate to="/" replace />;
  }

  return <EditCompanyPage />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/company",
)({
  component: EditCompanyRoute,
});
